export var ShowingEntity;
(function (ShowingEntity) {
    ShowingEntity[ShowingEntity["ShowAll"] = 1] = "ShowAll";
})(ShowingEntity || (ShowingEntity = {}));
